export const realtorNameOutput = (
  business_name: string | null | undefined,
  first_name: string | null | undefined,
  last_name: string | null | undefined,
): string => {
  // 1. Check if business name exists and is not just empty spaces
  if (business_name?.trim()) {
    return business_name.trim();
  }

  // 2. Build and clean the full name
  const fullname = `${first_name ?? ""} ${last_name ?? ""}`.trim();
  if (fullname) {
    return fullname;
  }

  // 3. Fallback priority
  return "Realtor Name";
};
